import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as PassengerSearchService from '_services/passenger-search-service';

/**
 * Search for passengers by name
 * @param {Object} params - Search parameters
 * @param {string} params.iata - Airport IATA code (required)
 * @param {string} params.date - Date in YYYY-MM-DD format (required)
 * @param {string} params.searchTerm - Passenger name search term (required)
 */
export const searchPassengersDropdown = createAsyncThunk(
    'passengerSearchDropdown/searchPassengers',
    async (params) => {
        return PassengerSearchService.searchPassengers(params);
    }
);

const initialState = {
    searchResults: [],
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
    selectedPassenger: null,
};

const passengerSearchDropdownSlice = createSlice({
    name: 'passengerSearchDropdown',
    initialState,
    reducers: {
        // Reset the entire state
        resetPassengerDropdown: (state) => {
            state.searchResults = [];
            state.status = 'idle';
            state.error = null;
            state.selectedPassenger = null;
        },
        
        // Clear search results only
        clearPassengerDropdownSearch: (state) => {
            state.searchResults = [];
            state.status = 'idle';
            state.error = null;
        },
        
        // Set selected passenger
        setDropdownSelectedPassenger: (state, action) => {
            state.selectedPassenger = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(searchPassengersDropdown.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(searchPassengersDropdown.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.searchResults = action.payload || [];
            })
            .addCase(searchPassengersDropdown.rejected, (state, action) => {
                state.status = 'failed';
                state.searchResults = [];
                state.error = action.error.message;
            });
    },
});

// Export actions
export const { 
    resetPassengerDropdown, 
    clearPassengerDropdownSearch, 
    setDropdownSelectedPassenger,
} = passengerSearchDropdownSlice.actions;

// Export reducer
export default passengerSearchDropdownSlice.reducer;

// Selectors
export const selectPassengerDropdownResults = (state) => state.passengerSearchDropdown.searchResults;
export const selectPassengerDropdownStatus = (state) => state.passengerSearchDropdown.status;
export const selectPassengerDropdownError = (state) => state.passengerSearchDropdown.error;
export const selectDropdownSelectedPassenger = (state) => state.passengerSearchDropdown.selectedPassenger;

// Derived selectors
export const selectIsPassengerDropdownLoading = (state) => state.passengerSearchDropdown.status === 'loading';
export const selectHasPassengerDropdownResults = (state) => 
    state.passengerSearchDropdown.status === 'succeeded' && 
    state.passengerSearchDropdown.searchResults.length > 0;
